import { GEREKCE_AGIR_EN_AZ } from "@koclukpanel/contracts";
import type { KagitRizaTuru } from "./api";

/** F-LGL-03c — imzalı sürüm asla otomatik olarak yayın sürümüne yükseltilmez. */
export function kagitOnayHazirMi(
  belgeVar: boolean,
  gerekce: string,
  kayitlar: ReadonlyArray<{ tur: KagitRizaTuru; surum: string }>,
  yayinda: ReadonlyArray<{ tur: KagitRizaTuru; surum: string }>,
): boolean {
  return (
    belgeVar &&
    gerekce.trim().length >= GEREKCE_AGIR_EN_AZ &&
    kayitlar.length > 0 &&
    kayitlar.every(
      (k) =>
        k.surum.trim() !== "" && k.surum.trim() === yayinda.find((m) => m.tur === k.tur)?.surum,
    )
  );
}
